import Vue from 'vue'
import Router from 'vue-router'
import Store from './store/index'
import Home from './views/Home.vue'
import Login from './views/Login'
import Users from './views/users/Users'
import DemandProfiles from './views/demand-profiles/DemandProfiles'
import GameVersions from './views/game-versions/GameVersions'
import GameVersionEdit from './views/game-versions/edit/GameVersion-edit'
import Companies from './views/game-versions/edit/companies/Companies'
import GameVersionParams from './views/game-versions/edit/params/Params'
import GameVersionStyle from './views/game-versions/edit/style/Style'
import GameVersionGraph from './views/game-versions/edit/graph/Graph'
import Games from './views/games/Games'
import Ingame from './views/in-game/Ingame'
import IngameCompanies from './views/in-game/pages/Companies'
import InGameResume from './views/in-game/pages/Resume'
import InGameOrders from './views/in-game/pages/Orders'
import InGameCost from './views/in-game/pages/Cost'
import InGameStock from './views/in-game/pages/StockDelay'
import InGameDemands from './views/in-game/pages/Demands'
import InGameBuffers from './views/in-game/pages/Buffers'
import InGameParams from './views/in-game/pages/Params'
import InGameReports from './views/in-game/pages/report/index'
import InGameGraph from './views/in-game/pages/Graph'


import Instructions from './views/instructions/Instructions'
import Tokens from './views/tokens/Tokens'
import Profile from './views/users/User-profile.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { requiresAuth: true }
    },
    {
      path: '/games',
      name: 'Games',
      component: Games,
      meta: { requiresAuth: true }
    },
    {
      path: '/game-versions',
      name: 'GameVersions',
      component: GameVersions,
      meta: { requiresAuth: true }
    },
    {
      path: '/in-game/:game',
      name: 'Ingame',
      component: Ingame,
      meta: { requiresAuth: true },
      children: [
        {
          path: 'companies',
          name: 'IngameCompanies',
          component: IngameCompanies,
          meta: { requiresAuth: true }
        },
        {
          path: 'resume',
          name: 'Resume',
          component: InGameResume,
          meta: { requiresAuth: true }
        },
        {
          path: 'orders',
          name: 'InGameOrders',
          component: InGameOrders,
          meta: { requiresAuth: true }
        },
        {
          path: 'cost',
          name: 'InGameCost',
          component: InGameCost,
          meta: { requiresAuth: true }
        },
        {
          path: 'stock',
          name: 'InGameStock',
          component: InGameStock,
          meta: { requiresAuth: true }
        },
        {
          path: 'demands/:company',
          name: 'InGameDemands',
          component: InGameDemands,
          meta: { requiresAuth: true }
        },
        {
          path: 'buffers',
          name: 'InGameBuffers',
          component: InGameBuffers,
          meta: { requiresAuth: true }
        },
        {
          path: 'params',
          name: 'InGameParams',
          component: InGameParams,
          meta: { requiresAuth: true }
        },
        {
          path: 'reports',
          name: 'InGameReports',
          component: InGameReports,
          meta: { requiresAuth: true }
        },
        {
          path: 'graph',
          name: 'InGameGraph',
          component: InGameGraph,
          meta: { requiresAuth: true }
        }
        
      ]
    },
    {
      path: '/game-versions/:id',
      name: 'GameVersionEdit',
      component: GameVersionEdit,
      meta: { requiresAuth: true },
      children: [
        {
          path: 'companies',
          name: 'Companies',
          component: Companies,
          meta: { requiresAuth: true }
        },
        {
          path: 'params',
          name: 'GameVersionParams',
          component: GameVersionParams,
          meta: { requiresAuth: true }
        },
        {
          path: 'style',
          name: 'GameVersionStyle',
          component: GameVersionStyle,
          meta: { requiresAuth: true }
        },
        {
          path: 'graph',
          name: 'GameVersionGraph',
          component: GameVersionGraph,
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
      meta: { requiresAuth: true }
    },
    {
      path: '/demand-profiles',
      name: 'DemandProfiles',
      component: DemandProfiles,
      meta: { requiresAuth: true }
    },
    {
      path: '/instructions',
      name: 'Instructions',
      component: Instructions,
      meta: { requiresAuth: true }
    },
    {
      path: '/tokens',
      name: 'Tokens',
      component: Tokens,
      meta: { requiresAuth: true }
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: { requiresAuth: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!Store.state.user.auth) {
      next({
        path: '/login'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router